import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  colors,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import details from "../../../src/assests/images/Task-detail.svg";
import greencheck from "../../../src/assests/images/green_check.svg";
import arrowred from "../../../src/assests/images/arrow-red.svg";
import TasksApproval from "./TasksApproval";
import {
  getTasksToApprove,
  reassigntask,
  taskApproveOrRejcet,
  verifeidbypmi,
} from "./apis";
import { getToken } from "../../utils/utils";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { Margin, Padding } from "@mui/icons-material";
import { format } from "date-fns";

type LabelOne = {
  label: string;
  span: string;
};

type LabelTwo = {
  label: string;
  span: string;
};

type GridCardBox = {
  label: string;
  span: string;
  src: string;
  bgColor: string;
  labelColor: string;
  spanColor: string;
};

type SideDrawerprops = {
  header: string;
  dynamictexts: LabelOne[];
  sidehead: string;
  gridcard: GridCardBox[];
  rejectheader: string;
  rejected: string;
  rejectdynamictexts: LabelTwo[];
  idApproved: string;
};

type ApprovalDrawerProps = {
  SideDrawer: SideDrawerprops[];
  rows: { id: string;[key: string]: any };
  datayaya: any;
  onClick?: () => void;
  value112: any;
  finaldata22: any;
  selectedLocation: any;
  SelectedTaskId: any;
  debouncedSearchTerm: any;
  pageindex: any;
  limit: any;
};
type Task = {
  action: any;
  id: null | undefined;
  pmi_entity_code: string;
  task_en: string;
};
type TaskDetail = {
  id: string; // or number, depending on your data
  // Add other properties here if needed
};
const ApprovalDrawer: React.FC<ApprovalDrawerProps> = ({
  SideDrawer,
  rows,
  datayaya,
  onClick,
  value112,
  finaldata22,
  selectedLocation,
  SelectedTaskId,
  debouncedSearchTerm,
  pageindex,
  limit,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [open, setOpen] = useState(false);
  const [rejectMode, setRejectMode] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const [isChecked, setIsChecked] = useState(true);
  // const [remarksddata, setremarks] = useState<string | null>(null);
  const [totals, setTotals] = useState({
    in_progress: 0,
    rejected: 0,
    approved: 0,

    verified_by_pmi: 0,
  });
  const [totalsapproval, setTotalsapproval] = useState({
    in_progress: 0,
    rejected: 0,
    approved: 0,

    verified_by_pmi: 0,
  });
  const handleBackClick = () => {
    toggleDrawer(false)(); // Call the drawer close
    navigate("/tasks-approval"); // Then navigate
  };

  const [selectedTabId, setSelectedTabId] = useState<number | null>(null);
  const [tasksData, settasksData] = useState<Task[]>([]);
  const [tasksDatavalues, settaskvalue] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSubmittedverify, setIsSubmittedverify] = useState(false);
  useEffect(() => {
    if (open === false) {
      setIsSubmittedverify(false);
    }
  }, [open]);

  console.log(value112, "value112value112");
  console.log(
    finaldata22.map((item: { id: any }) => item.id),
    "finaldata22finaldata22finaldata2222222"
  );
  useEffect(() => {
    if (location.state?.valuetabsdata) {
      console.log(location.state.valuetabsdata, "jjjjjjjjjjjjjjjjjjj");
      setSelectedTabId(location.state.valuetabsdata);
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.selectedDatevaluevaluefdgfg) {
      console.log(
        location.state.selectedDatevaluevaluefdgfg,
        "selectedDatevaluevaluefdgfgselectedDatevaluevaluefdgfg"
      );
      settaskvalue(location.state.selectedDatevaluevaluefdgfg);
    }
  }, [location.state]);

  console.log(selectedTabId, "selectedtabids344555");

  const toggleDrawer = (isOpen: boolean) => () => {
    setOpen(isOpen);
  };
  const handleDetailsClick = (id: string) => {
    setSelectedId(id);
    setOpen(true);
  };

  console.log(selectedId, "selectedIdselectedId45454");

  console.log(SideDrawer, "SideDrawerSideDrawer");

  const filterdata = selectedId
    ? datayaya.filter((item: { id: string }) => item.id === selectedId)
    : [];
  console.log(filterdata, "filterdatav44444444");
  const token = getToken();

  useEffect(() => {
    if (selectedId !== undefined && selectedId !== null) {
      navigate("/tasks-approval", { state: { selectedId } });
    }
  }, [selectedId, navigate]);

  type FilterItem = {
    action?: {
      [key: string]: any;
    };
  };

  const accountidss =
    filterdata.length > 0
      ? filterdata
        .map(
          (item: { action: { [key: string]: any } }) =>
            item.action["retailer.contact_id"]
        )
        .join(",")
      : "";

  const taskidsss =
    filterdata.length > 0
      ? filterdata
        .map(
          (item: { action: { [key: string]: any } }) =>
            item.action["task.task_id"]
        )
        .join(",")
      : "";

  console.log("Extracted taskidsss:", taskidsss);
  console.log("Extracted accountidss:", accountidss); console.log(taskidsss, "taskidssstaskidsssyyyy");
  const taskidsssAlternative =
    filterdata.length > 0
      ? filterdata
        .map((item: any) => {
          try {
            if (item?.action?.task?.task_id) {
              return item.action.task.task_id;
            }
            return null;
          } catch (error) {
            console.warn("Error accessing task_id for item:", item, error);
            return null;
          }
        })
        .filter((id: string | null): id is string => id !== null) // 👈 fixes TS7006 and narrows to string
        .join(",")
      : "";

  type FilterDataItem = {
    id: string;
    action: {
      "retailer.contact_id"?: string;
      task?: {
        task_id?: any;
      };
    };
  };
  console.log("filterdata structure:", filterdata);
  if (filterdata.length > 0) {
    console.log("First item structure:", filterdata[0]);
    console.log("First item action:", filterdata[0]?.action);
    console.log("First item task:", filterdata[0]?.action?.task);
  }

  const handleApprove = async () => {
    const token = getToken();

    const reqBody: {
      accountId: string;
      task_id: string;
      status: "approved" | "rejected";
      remarks: string;
      id: string;
    } = {
      accountId: accountidss,
      task_id: taskidsss,
      status: "approved",
      remarks: "",
      id: filterdata.map((item: { id: any }) => item.id).join(","),
    };

    try {
      const response = await taskApproveOrRejcet(reqBody, token);
      if (response) {
        console.log("Task approved successfully!");
        // alert(`Verification completed for tab ID: ${selectedTabId}`);

        setIsApproved(true);
        //    const queryParams = {
        //   status: "approved",
        //   location: selectedLocation || "",
        //   task_id: SelectedTaskId || "",
        //   search: debouncedSearchTerm || "",
        //   page: pageindex || "",
        //   limit: limit || "",
        // };

        // const tasksResponse = await getTasksToApprove(
        //   token,
        //   queryParams.status,
        //   queryParams.search,
        //   queryParams.page,
        //   queryParams.limit,
        //   queryParams.location,
        //   queryParams.task_id
        // );

        //     if (tasksResponse?.status) {
        //       const filteredData =
        //         tasksResponse.data?.data?.map((item: any) => ({
        //           id: item.id,
        //           pmi_entity_code: item.pmi_entity_code || "",
        //           task_en: item["task.task_en"] || "",
        //           task_type_en: item["task.task_type_en"] || "",
        //           outlet_name: item.outlet_name || "",
        //           approval_status: item.approval_status || "",
        //           remarks: item.remarks || "",
        //           locations: item.locations,
        //           reassign_account_length: item.reassign_account_length,
        //           verified_by_pmi: item.verified_by_pmi,
        //           updated_at: item.updated_at
        //             ? format(new Date(item.updated_at), "dd MMM yyyy")
        //             : "",
        //           action: item,
        //           tabname:"approved"
        //         })) || [];

        //       settasksData(filteredData);
        // console.log(filteredData, "filteredData55555555")
        // setTotalsapproval(
        //         tasksResponse.data?.totals || {
        //           in_progress: 0,
        //           rejected: 0,
        //           approved: 0,
        //           verified_by_pmi: 0,
        //         }
        //       );
        //     }
      }
    } catch (error) {
      console.error("Error while approving task:", error);
    }
    console.log("Approved");
    setIsDisabled(true); // Disable both buttons
  };
  const [taskdetails, settaskdetails] = useState<TaskDetail[]>([]);

  useEffect(() => {
    if (location.state?.tasksDatatasksDatatasksData22) {
      console.log(
        location.state.tasksDatatasksDatatasksData22,
        "location.state.tasksDatatasksDatatasksData22"
      );
      settaskdetails(location.state.tasksDatatasksDatatasksData22);
    }
  }, [location.state]);
  console.log(taskdetails, "888888887471566396");
  console.log(selectedId, "cccccddddddddddd");
  const filteredTasks =
    taskdetails.length > 0
      ? taskdetails.filter((item) => item.id == selectedId)
      : [];
  console.log(filteredTasks, "bfilteredTasksdhfihreiuhtire");

  console.log(isChecked, "isCheckedisCheckedisChecked");
  const handleRejectClickee = async () => {
    setIsSubmitted(true);

    const token = getToken();

    const reqBody: {
      accountId: string;
      task_id: string;
      status: "approved" | "rejected";
      remarks: string;
      publish_id: string;
      reassigntask: boolean;
      id: string;
    } = {
      accountId: accountidss,
      task_id: taskidsss,
      status: "rejected",
      remarks: remarksddata || "",
      publish_id: filteredTasks.map((item) => item.id).join(","),
      reassigntask: isChecked === true,
      id: filterdata.map((item: { id: any }) => item.id).join(","),
    };

    try {
      const response = await taskApproveOrRejcet(reqBody, token);

      console.log("API Response:", response);
      console.log("API Response Data:", response.data);
      console.log("API Response Data Object:", response.data?.data);
      if (response) {
        // const queryParams = {
        //   status: "approved",
        //   location: selectedLocation || "",
        //   task_id: SelectedTaskId || "",
        //   search: debouncedSearchTerm || "",
        //   page: pageindex || "",
        //   limit: limit || "",
        // };
        // const tasksResponse = await getTasksToApprove(
        //   token,
        //   queryParams.status,
        //   queryParams.search,
        //   queryParams.page,
        //   queryParams.limit,
        //   queryParams.location,
        //   queryParams.task_id
        // );
        //     if (tasksResponse?.status) {
        //       const filteredData =
        //         tasksResponse.data?.data?.map((item: any) => ({
        //           id: item.id,
        //           pmi_entity_code: item.pmi_entity_code || "",
        //           task_en: item["task.task_en"] || "",
        //           task_type_en: item["task.task_type_en"] || "",
        //           outlet_name: item.outlet_name || "",
        //           approval_status: item.approval_status || "",
        //           remarks: item.remarks || "",
        //           locations: item.locations,
        //           reassign_account_length: item.reassign_account_length,
        //           verified_by_pmi: item.verified_by_pmi,
        //           updated_at: item.updated_at
        //             ? format(new Date(item.updated_at), "dd MMM yyyy")
        //             : "",
        //           action: item,
        //           tabname:"rejected"
        //         })) || [];
        //       settasksData(filteredData);
        // console.log(filteredData, "filteredData55555555")
        //       setTotals(
        //         tasksResponse.data?.totals || {
        //           in_progress: 0,
        //           rejected: 0,
        //           approved: 0,
        //           verified_by_pmi: 0,
        //         }
        //       );
        //     }
      }
    } catch (error) {
      console.error("Error while rejecting task:", error);
    }

    console.log("Rejected");
  };
  console.log(isSubmitted, "isSubmittedisSubmitted");
  console.log(selectedTabId, "selectedTabIdselectedTabId444");
  const handleRejectClick = () => {
    setRejectMode(true);
    console.log("Rejected");
  };

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#282829",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#282829",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "400",
      padding: "6px 12px",
    },
  }));

  console.log(selectedTabId, "selectedTabIdselectedTabId");
  console.log(totals, "totakstotasltotalsd");
  console.log(totalsapproval, "totalsapprovaltotalsapproval");

  useEffect(() => {
    if (totals) {
      console.log(totals, "totals44444444444444444444");
      navigate(`/tasks-approval`, { state: { totalcount122a45: totals } });
    }
  }, [totals]);

  const prevSelectedapproved = useRef({ isApproved });

  useEffect(() => {
    console.log(rejectMode, "tasksData4444444444444");

    if (
      isApproved &&
      JSON.stringify(isApproved) !==
      JSON.stringify(prevSelectedapproved.current.isApproved)
    ) {
      console.log(isApproved, "isApprovedisApprovedisApproved4434");

      navigate(`/tasks-approval`, {
        state: { taskApproval: isApproved },
      });

      prevSelectedapproved.current = { isApproved };
    }
  }, [isApproved]);
  const prevSelectedRejected = useRef({ isSubmitted });
  useEffect(() => {
    console.log(isSubmitted, "tasksData4444444444444");

    if (
      isSubmitted &&
      JSON.stringify(isSubmitted) !==
      JSON.stringify(prevSelectedRejected.current.isSubmitted)
    ) {
      console.log(isSubmitted, "rejectModerejectModerejectModerejectMode");

      navigate(`/tasks-approval`, {
        state: { taskRejecteddata: isSubmitted },
      });

      prevSelectedRejected.current = { isSubmitted };
    }
  }, [isSubmitted]);



  const prevSelectedlocationss = useRef(tasksData);
  console.log(tasksData, "tasksData4444444444444");
  useEffect(() => {
    if (
      tasksData.length > 0 &&
      JSON.stringify(tasksData) !==
      JSON.stringify(prevSelectedlocationss.current)
    ) {
      console.log(tasksData, "selectedLocations55");
      navigate(`/tasks-approval`, {
        state: { tasksDatatasksDffdata213: tasksData },
      });
      prevSelectedlocationss.current = tasksData;
    }
  }, [tasksData]);

  console.log(tasksData, "tasksData23434345");

  const [remarksddata, setremarks] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const handleRejectSubmit = () => {
    console.log("Submit clicked with remarks:", remarksddata);
    // Add your rejection logic here
  };

  const handleDrawerToggle = (isOpen: boolean) => () => {
    setOpen(isOpen);
  };

  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsChecked(event.target.checked);
  };
  console.log(isChecked, "isCheckedisCheckedisCheckedisCheckedisChecked");
  console.log(SideDrawer, "SideDrawerSideDrawerSideDrawer");

  const prevSelectedlocations = useRef(isChecked);
  useEffect(() => {
    if (
      isChecked !== null &&
      JSON.stringify(isChecked) !==
      JSON.stringify(prevSelectedlocations.current)
    ) {
      console.log(isChecked, "selectedLocations55");
      navigate(`/tasks-approval`, {
        state: { isCheckedisCheckedisChecked: isChecked },
      });
      prevSelectedlocations.current = isChecked;
    }
  }, [isChecked]);
  const maxCharacters = 200;
  const [remarks, setRemarks] = useState("");

  const handleCombinedChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let inputText = e.target.value;

    // inputText = inputText.replace(/[^a-zA-Z\s]/g, "");

    if (inputText.length <= maxCharacters) {
      setRemarks(inputText);
    }
  };

  // Function to handle pasted content
  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault(); // Prevent the default paste behavior

    // Get the pasted text
    const pastedText = e.clipboardData.getData("text");

    // Process the pasted text
    let processedText = pastedText.replace(/[^a-zA-Z\s]/g, "");

    // Combine current input with pasted text
    const combinedText = remarks + processedText;

    // Update state only if combined length is within the limit
    if (combinedText.length <= maxCharacters) {
      setRemarks(combinedText);
    } else {
      setRemarks(combinedText.slice(0, maxCharacters)); // Trim excess
    }
  };

  console.log(rejectMode, "rejectMode4444444444");
  console.log(open, "openopenopenopenopenopen");

  const prevSelectedopen = useRef(open);
  console.log(open, "tasksData4444444444444");
  useEffect(() => {
    if (
      open &&
      JSON.stringify(open) !== JSON.stringify(prevSelectedopen.current)
    ) {
      console.log(tasksData, "selectedLocations55");
      navigate(`/tasks-approval`, {
        state: { tasksDataopen: open },
      });
      prevSelectedopen.current = open;
    }
  }, [open]);

  const prevSelectedwww = useRef(selectedId);
  console.log(selectedId, "tasksData4444444444444");
  useEffect(() => {
    console.log("Effect triggered: selectedId = ", selectedId);
    console.log("Previous selectedId: ", prevSelectedwww.current);

    if (
      selectedId !== null &&
      JSON.stringify(selectedId) !== JSON.stringify(prevSelectedwww.current)
    ) {
      console.log("Navigating to tasks-approval with selectedId:", selectedId);
      navigate(`/tasks-approval`, {
        state: { tasksselectedIdee: selectedId },
      });

      prevSelectedwww.current = selectedId;
    }
  }, [selectedId, navigate]);

  const [isCorrectChecked, setIsCorrectChecked] = useState(false);
  const [isUncorrectChecked, setIsUncorrectChecked] = useState(false);

  // Handle "Correct" checkbox
  const handleCorrectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setIsCorrectChecked(event.target.checked);
    const checked = event.target.checked;
    setIsCorrectChecked(checked);
    setIsUncorrectChecked(false);
  };
  console.log(isCorrectChecked, "isCorrectCheckedeeeeeee");
  console.log(isUncorrectChecked, "isUncorrectCheckedeeeee");
  // Handle "Uncorrect" checkbox
  const handleUncorrectChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    //setIsUncorrectChecked(event.target.checked);
    const checked = event.target.checked;
    setIsUncorrectChecked(checked);
    setIsCorrectChecked(false);
  };

  const handleRemarksChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setremarks(e.target.value);
    handleCombinedChange(e);
  };

  const handleVerify = async (): Promise<void> => {
    try {
      setIsSubmittedverify(true);
      const token = getToken();
      const userTaskMappingIds = finaldata22.map(
        (item: { id: any }) => item.id
      );

      const reqBody = {
        user_task_mapping_id: userTaskMappingIds.join(","),
        status: isCorrectChecked ? "iscorrect" : isUncorrectChecked ? "isuncorrect" : "",

        remarks: remarksddata
      };

      const verificationResponse = await verifeidbypmi(reqBody, token);
      if (verificationResponse) {
        console.log("Task approved successfully!");
        // alert(`Verification completed for tab ID: ${selectedTabId}`);
      }
    } catch (error) {
      console.error(
        "Error while processing verification or fetching tasks:",
        error
      );
      alert("An error occurred during verification. Please try again.");
    }

    // console.log("Verification action triggered for tab:", selectedTabId);
  };


  console.log(isSubmittedverify, "kkkkkkkkkssssssssssss")
  const prevSelectedisSubmittedverify = useRef({ isSubmittedverify });
  useEffect(() => {
    console.log(isSubmittedverify, "tasksData4444444444444ss");

    if (
      isSubmittedverify &&
      JSON.stringify(isSubmittedverify) !==
      JSON.stringify(prevSelectedisSubmittedverify.current.isSubmittedverify)
    ) {
      console.log(
        isSubmittedverify,
        "rejectModerejectModerejectModerejectMode"
      );

      navigate(`/tasks-approval`, {
        state: { isSubmittedverify55: isSubmittedverify },
      });

      prevSelectedisSubmittedverify.current = { isSubmittedverify };
    }
  }, [isSubmittedverify]);



  // Check if button should be enabled
  const isButtonEnabled =
    isCorrectChecked || (isUncorrectChecked && remarks.trim() !== "");




  console.log(remarksddata, "remarksddataremarksddata");
  console.log(isSubmittedverify, "isSubmittedverifyisSubmittedverify")
  console.log(open, "openeeeeeeeeeeeeeeeeeeeeeee")

  //Checkbox changed to like radio option

  return (
    <div>
      <BootstrapTooltip title="View Task Details">
        <Button onClick={() => handleDetailsClick(rows.id)}>
          <img src={details} alt="details" />
        </Button>
      </BootstrapTooltip>

      {SideDrawer.map((section, index) => (
        <Drawer
          key={index}
          open={open}
          onClose={toggleDrawer(false)}
          anchor="right"
        >
          {/* {selectedTabId == 2 && <h2>Approved</h2>} */}

          {!rejectMode && (
            <Box className="main-box">
              <Box
                sx={{ width: 650, padding: "24px 32px" }}
                role="presentation"
                onClick={toggleDrawer(true)}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px dashed rgba(231, 232, 233, 1)",
                    paddingBottom: "12px",
                    marginBottom: "24px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "24px", fontWeight: "600" }}
                    variant="h4"
                  >
                    {" "}
                    {section.header}
                  </Typography>
                  {isApproved && (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "rgba(11, 160, 17, 1)",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "rgba(255, 255, 255, 1)",
                        border: "1px solid rgba(146, 219, 139, 1)",
                        padding: "12px",
                        borderRadius: "12px",
                      }}
                      variant="body2"
                    >
                      <Box
                        sx={{
                          background: "rgba(235, 247, 230, 1)",
                          padding: "9px",
                          borderRadius: "50%",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <img src={greencheck} alt="greencheck" />
                      </Box>{" "}
                      {section.idApproved}
                    </Typography>
                  )}
                </Box>
                {section.dynamictexts.map((text, idx) => (
                  <Typography
                    key={idx}
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      paddingBottom: "12px",
                      color: "rgba(105, 106, 107, 1)",
                    }}
                    variant="h4"
                  >
                    {text.label}
                    <span
                      style={{ color: "rgba(4, 45, 96, 1)", fontWeight: "600" }}
                    >
                      {text.span}
                    </span>
                  </Typography>
                ))}

                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    paddingBottom: "12px",
                    padding: "24px 0 12px",
                    borderBottom: "1px dashed rgba(231, 232, 233, 1)",
                  }}
                >
                  {section.sidehead}
                </Typography>

                <Grid sx={{ marginTop: "24px" }} container spacing={2}>
                  {section.gridcard.map((gridsection, idx) => (
                    <Grid
                      key={idx}
                      sx={{
                        padding: "0 12px !important",
                        marginBottom: "24px",
                      }}
                      md={6}
                    >
                      <Box
                        sx={{
                          background: gridsection.bgColor,
                          borderRadius: "12px",
                          padding: "12px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "500",
                            marginBottom: "12px",
                            color: gridsection.labelColor,
                          }}
                          variant="body1"
                        >
                          {gridsection.label}
                          <span style={{ color: gridsection.spanColor }}>
                            {gridsection.span}
                          </span>
                        </Typography>

                        <img
                          style={{
                            maxWidth: "100%",
                            height: "266px",
                            objectFit: "cover",
                          }}
                          src={gridsection.src}
                          alt="pack"
                          crossOrigin="anonymous"
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          )}

          <Box>
            {value112 === 2 ? (
              <>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "24px",
                    paddingLeft: "32px",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isCorrectChecked}
                        onChange={handleCorrectChange}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "500",
                          color: "rgba(73, 74, 75, 1)",
                        }}
                      >
                        Correct
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isUncorrectChecked}
                        onChange={handleUncorrectChange}
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "500",
                          color: "rgba(73, 74, 75, 1)",
                        }}
                      >
                        Uncorrect
                      </Typography>
                    }
                  />
                </Box>
                {isUncorrectChecked && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "500",
                        padding: "0 32px",
                        marginTop: "20px"
                      }}
                      variant="h4"
                    >
                      {" "}
                      Reason*
                    </Typography>
                    <Box sx={{ padding: "0 32px", marginTop: "16px" }}>
                      <TextField
                        multiline
                        rows={7}
                        variant="outlined"
                        fullWidth
                        value={remarks}
                        onChange={handleRemarksChange}
                        onPaste={handlePaste}
                        placeholder="Please write your question"
                        InputProps={{
                          sx: {
                            background: "rgba(243, 244, 246, 1)",
                            "& .MuiInputBase-input::placeholder": {
                              color: "#525252",
                            },
                          },
                        }}
                      />
                    </Box>
                  </>
                )}
                <Box
                  sx={{
                    position: "sticky",
                    bottom: "0",
                    background: "#FFF",
                    right: "0",
                    borderTop: "1px solid #E7E8E9",
                    padding: "16px 32px",
                    width: "100%",
                    marginTop: "50px",

                  }}
                >
                  <Button
                    onClick={() => {
                      handleVerify();  // Call handleVerify function
                      if (isButtonEnabled) {
                        toggleDrawer(false)();
                      }
                    }}

                    disabled={!isButtonEnabled}
                    sx={{
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "500",
                      padding: "10px 61px",
                      background: isButtonEnabled ? "#C8172F" : "#B0B0B0",
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      float: "right",
                      marginBottom: "20px",
                      ":hover": { background: "#C8172F", color: "#FFF" },

                    }}
                  >
                    submit
                  </Button>
                </Box>
              </>
            ) : (
              <>
                {!rejectMode && (
                  <>
                    <Box sx={{ display: "flex", alignItems: "center", borderTop: "1px solid #E7E8E9", padding: "16px 32px" }}>
                      <Button
                        onClick={handleBackClick}
                        sx={{
                          marginRight: "auto",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "rgba(200, 23, 47, 1)",
                          textTransform: "unset",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{ marginRight: "8px" }}
                          src={arrowred}
                          alt="arrowred"
                          height={16}
                          width={16}
                        />
                        Back
                      </Button>

                      <Button
                        onClick={handleRejectClick}
                        sx={{
                          textTransform: "unset",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "rgba(200, 23, 47, 1)",
                          border: isDisabled
                            ? "0"
                            : "1px solid rgba(200, 23, 47, 1)",
                          borderRadius: "8px",
                          padding: "10px 61px !important",
                          marginRight: "8px",
                          // backgroundColor: isDisabled ? "rgba(211, 211, 211, 1)" : "transparent",
                          opacity: isDisabled ? "0.5" : "1",
                        }}
                        disabled={isDisabled}
                      >
                        Reject
                      </Button>
                      <Button
                        onClick={handleApprove}
                        sx={{
                          textTransform: "unset",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#fff",
                          background: "rgba(200, 23, 47, 1)",
                          borderRadius: "8px",
                          padding: "10px 61px !important",
                          // backgroundColor: isDisabled ? 'grey' : ' red',
                          opacity: isDisabled ? "0.5" : "1",
                          ":hover": { background: "#C8172F", color: "#FFF" },
                        }}
                        disabled={isDisabled}
                      >
                        Approve
                      </Button>
                    </Box>
                  </>
                )}
              </>
            )}
          </Box>

          {rejectMode && (
            <>
              <Box
                className="rejectshow"
                sx={{ width: 650, padding: "24px 32px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px dashed rgba(231, 232, 233, 1)",
                    paddingBottom: "12px",
                    marginBottom: "24px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "24px", fontWeight: "600" }}
                    variant="h4"
                  >
                    {section.rejectheader}
                  </Typography>
                  <Typography
                    sx={{
                      color: "red",
                      background: "rgba(254, 241, 239, 1)",
                      padding: "6px",
                      borderRadius: "8px",
                    }}
                    variant="body2"
                  >
                    {section.rejected}
                  </Typography>
                </Box>

                {section.rejectdynamictexts.map((text, idx) => (
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      paddingBottom: "12px",
                      color: "rgba(105, 106, 107, 1)",
                    }}
                    variant="h4"
                  >
                    {text.label}
                    <span
                      style={{ color: "rgba(4, 45, 96, 1)", fontWeight: "600" }}
                    >
                      {text.span}
                    </span>
                  </Typography>
                ))}

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "24px 0 6px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    variant="h4"
                  >
                    {" "}
                    Reason*
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "14px",
                      color: "#7D7E7F",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    {remarks.length}/{maxCharacters}
                  </Typography>
                </Box>

                <FormGroup>
                  <TextField
                    multiline
                    rows={7}
                    variant="outlined"
                    fullWidth
                    value={remarks}
                    onChange={(e) => {
                      setremarks(e.target.value); // Update the state
                      handleCombinedChange(e); // Perform additional logic
                    }}
                    onPaste={handlePaste}
                    placeholder="Please write a reason of rejection"
                    InputProps={{
                      sx: {
                        background: "rgba(243, 244, 246, 1)",
                        "& .MuiInputBase-input::placeholder": {
                          color: "#525252",
                        },
                      },
                    }}
                  />
                  {/* <FormControlLabel
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "rgba(73, 74, 75, 1)",
                    }}
                    control={<Checkbox defaultChecked />}
                    label="Reassign the task right now"
                  /> */}
                  <FormControlLabel
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "rgba(73, 74, 75, 1)",
                    }}
                    control={
                      <Checkbox
                        checked={isChecked} // Bind to state
                        onChange={handleCheckboxChange} // Handle change
                      />
                    }
                    label="Reassign the task right now"
                  />
                </FormGroup>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderTop: "1px solid rgba(231, 232, 233, 1)",
                  padding: "16px 32px",
                  position: "sticky",
                  bottom: "0",
                  background: "#FFF",
                  marginTop: "auto",
                }}
              >
                <Button
                  onClick={toggleDrawer(false)}

                  sx={{
                    marginRight: "auto",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "rgba(200, 23, 47, 1)",
                    textTransform: "unset",
                  }}
                >
                  {" "}
                  <img
                    style={{ marginRight: "8px" }}
                    src={arrowred}
                    alt="arrowred"
                    height={16}
                    width={16}
                  />{" "}
                  Back
                </Button>
                <Button
                  onClick={() => {
                    handleRejectClickee();
                    toggleDrawer(false);
                  }}
                  // disabled={remarks.trim().length === 0 || remarks.length >= maxCharacters}//
                  disabled={
                    remarks.length === 0 || remarks.length > maxCharacters
                  }
                  sx={{
                    textTransform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "10px 61px !important",
                    backgroundColor:
                      remarks.trim().length === 0 ||
                        remarks.length >= maxCharacters
                        ? "rgba(200, 23, 47, 0.5)"
                        : "rgba(200, 23, 47, 1)",
                  }}
                >
                  Submit
                </Button>
              </Box>
            </>
          )}
        </Drawer>
      ))}
    </div>
  );
};

export default ApprovalDrawer;

